export class TriggerConfigbodys {
  bvalue: string;
  bkey: string;
}
